import ResponsivePopup from './ResponsivePopup'

export type { ResponsivePopupProps } from './ResponsivePopup'
export default ResponsivePopup
